import Vue from 'vue'
import App from './App.vue'

import router from "./router/index.js";
import store from "./store";

import VueCurrencyInput from "vue-currency-input";
Vue.use(VueCurrencyInput);

import "../node_modules/bulma/css/bulma.min.css"
import "./../node_modules/@mdi/font/css/materialdesignicons.min.css"
import $buefy from "buefy";
import "buefy/dist/buefy.css";
Vue.use($buefy);

//import { ToastProgrammatic as Toast } from 'buefy'


import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css' // import the croppie css manually
Vue.use(VueCroppie);

import _axios from "axios"
import { cacheAdapterEnhancer } from 'axios-extensions';
const axios = _axios.create({
  baseURL: '/',
  headers: { 'Cache-Control': 'no-cache' },
  // disable the default cache and set the cache flag
  adapter: cacheAdapterEnhancer(_axios.defaults.adapter, { enabledByDefault: false, cacheFlag: 'useCache' })
});

axios.interceptors.request.use(req => {
  // `req` is the Axios request config, so you can modify
  // the `headers`.
  store.commit("setLoading");

  if (req.url.includes("api")) {
    const token = store.getters.token;
    req.headers.authorization = `Bearer ${token}`;
  }

  if (req.url.includes("viacep")) {
    req.headers = {};
  }

  return req;
});
axios.interceptors.response.use(
  (response) => {
    //const now = Date.now();
    //console.info(`Api Call ${response.config.url} took ${now - response.config.config.start}ms`);
    store.commit("setLoading", false);
    //Snackbar.open(`positioned bottom-right with a green 'OK' button`)
    return response;
  },
  (error) => {
    switch (error.response.status) {
      case 401:
        router.push("/login");
        break;
      case 403:
        router.push("/403");
        break;
      //case 404:
      //Snackbar.open("404! Arquivo não encontrado");
      //break;
      case 500:
        this.$buefy.Toast.open({
          message: error.response.data,
          type: "is-danger",
        });
        break;
    }
    store.commit("setLoading", false);
    return Promise.reject(error)
  },
);
Vue.prototype.$http = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
